import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import InputItem from '../../InputItem';
import SelectWrapper from '../../../atoms/SelectWrapper';
import FilterSelectItem from '../../FilterSelectItem';
import { useTranslation } from 'react-i18next';
const Filters = ({ availableFilters = {}, data, errors = {}, setData, }) => {
    const { t } = useTranslation();
    return (_jsx(_Fragment, { children: Object.keys(availableFilters).map((filterName, index) => {
            const filter = availableFilters[filterName];
            if (filter.type === 'text') {
                return (_jsx(InputItem, { label: filter.label, placeholder: filter.placeholder, 
                    // @ts-ignore
                    value: data.filters[filterName], 
                    // @ts-ignore
                    error: errors[`filters.${filterName}`], onChange: e => setData('filters', {
                        ...data.filters,
                        [filterName]: e.target.value,
                    }) }, `${filterName}-${index}`));
            }
            if (filter.type === 'select' && filter.options) {
                let SelectOptions = [];
                filter.options.forEach(option => {
                    SelectOptions.push({
                        value: option || '',
                        label: t('filter.' + filterName + '.option.' + option),
                    });
                });
                return (_jsx(SelectWrapper, { children: _jsx(FilterSelectItem, { label: filter.label, options: SelectOptions, name: filterName, placeholder: filter.placeholder, 
                        // @ts-ignore
                        value: data.filters[filterName], 
                        // @ts-ignore
                        error: errors[`filters.${filterName}`], setFilter: (name, value) => setData('filters', {
                            ...data.filters,
                            [filterName]: value || '',
                        }) }) }, `${filterName}-${index}`));
            }
        }) }));
};
export default Filters;
